import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Shared handler for upload endpoints — surfaces a distinct, friendly toast when the
// per-user upload rate limit (429) is hit, instead of the generic red error toast.
export function showUploadError(err) {
  if (err?.response?.status === 429) {
    toast.warning("You're uploading a lot right now — please wait a few minutes and try again.", {
      duration: 6000,
    });
    return;
  }
  toast.error(formatApiError(err));
}
